module.exports = __webpack_public_path__ + "img/36.dab2f8ba.png";